import { Text } from '@radix-ui/themes'
import { formatDayWithYear } from '~/utils/date'
import { isLabelExpired, type MaterialReturn } from '../service'

interface LabelExpiryTextProps {
  materialReturn: Pick<MaterialReturn, 'received_at' | 'label_expires_on'>
  size?: '1' | '2'
}

export const LabelExpiryText = ({ materialReturn, size = '2' }: LabelExpiryTextProps) => (
  <Text size={size} color={isLabelExpired(materialReturn) ? 'red' : 'gray'} className="whitespace-nowrap">
    {formatDayWithYear(materialReturn.label_expires_on)}
  </Text>
)
